export default {
      id: "icon--star-outline-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--star-outline-usage",
      toString: function () {
        return this.url;
      }
    }